module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp/img_intro_list01-12df317e42b04a21514bad44bb35756c.png";